// Стили
import './Spinner.scss';
import { jsx as _jsx } from "react/jsx-runtime";
var Spinner = function Spinner(_ref) {
    var className = _ref.className, _ref$size = _ref.size, size = _ref$size === void 0 ? 'sm' : _ref$size;
    return /*#__PURE__*/ _jsx("span", {
        className: "spinner spinner--".concat(size, " ").concat(className || ''),
        "aria-hidden": "true"
    });
};
export default Spinner;
